import React from 'react';
import Contact from '@components/Pages/Login/Contact';

function Blocked() {
  return (
    <div className="text-center my-5">
      <h1>Your Identity has been blocked</h1>
      <Contact />
    </div>
  );
}

export default Blocked;
